import {
  ContentText,
  ContentWrapper,
  HeadlineSmall,
  HeadlineTiny,
  Image,
  RichTextContent,
} from "../../content/components";
import { Configuration, Photo, RichTextType } from "../../resources/modelTypes";
import { getPhotoByPk, RootState } from "../../resources/reduxTypes";
import React, { useMemo } from "react";
import { connect } from "react-redux";

export type AttendantProps = {
  configuration: Configuration;
  description: RichTextType;
  name: string;
  photo: string | null;
  photoPk: number | null;
  title: string;
};

type AttendantPropsWithRedux = {
  fullPhoto: Photo | null;
} & AttendantProps;

export const Attendant = ({
  configuration,
  description,
  fullPhoto,
  name,
  photo,
  title,
}: AttendantPropsWithRedux) => {
  const imageToDisplay = useMemo(
    () => photo || fullPhoto?.original || null,
    [fullPhoto?.original, photo],
  );

  return (
    <ContentWrapper
      imageAlignment={configuration.imageAlignment}
      textAlignment={configuration.textAlignment}
    >
      <Image
        image={imageToDisplay}
        imageAlignment={configuration.imageAlignment}
        imageSize={configuration.imageSize}
      />
      <ContentText textAlignment={configuration.textAlignment}>
        <div data-cy="subheading">
          <HeadlineSmall>{name}</HeadlineSmall>
        </div>
        <div data-cy="body">
          <HeadlineTiny>{title}</HeadlineTiny>
          <RichTextContent value={description} />
        </div>
      </ContentText>
    </ContentWrapper>
  );
};

const mapStateToProps = (state: RootState, props: AttendantProps) => ({
  fullPhoto: getPhotoByPk(state, props.photoPk),
});

// @ts-expect-error Force types for redux/react connection
export default connect(mapStateToProps)(Attendant) as React.FC<AttendantProps>;
